module.exports = __webpack_public_path__ + "4ace2eff0e5d5c057234f39115ac450f.pdf";